import * as easyFetch from "src/utils/fetch";
import type { LlmModel } from "src/ts-types";

/**
 * Fetch available LLM models
 * @returns {Promise<Array<LlmModel>>} Array of LLM models
 */
export const getLlmModels = async (): Promise<Array<LlmModel>> => {
  const models = await easyFetch.get("/llm-model");
  return Array.isArray(models) ? models : [];
};
